import { render, staticRenderFns } from "./CookingListPage.vue?vue&type=template&id=4f21192a&scoped=true&"
import script from "./CookingListPage.vue?vue&type=script&lang=js&"
export * from "./CookingListPage.vue?vue&type=script&lang=js&"
import style0 from "./CookingListPage.vue?vue&type=style&index=0&id=4f21192a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21192a",
  null
  
)

export default component.exports